import React, { Component, Fragment } from "react";
import Btn from "../../../components/atom/Btn";
import axios from "axios";
import Breadcrumb from "../../../components/organism/Breadcrumb";

export default class GP2Index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: [],
            retourData: []
        };
    }

    handleSerialChange = (event) => {
        this.setState({ serial: event.target.value.toUpperCase() });
    };

    handleSubmit = (event) => {
        event.preventDefault();

        const token = localStorage.getItem("token");
        const config = {
            headers: { Authorization: `Bearer ${token}` },
            params: { serial: this.state.serial },
        };

        axios
            .get(
                process.env.REACT_APP_API_URL + '/GP2/getCentraleEtat',
                config
            )
            .then((res) => {

                const data = res.data?.data;

                if (!data) {
                    this.props.history.push({
                        pathname: "/GP2AucunResultats",
                        state: {
                            serial: this.state.serial
                        }
                    });

                    return;
                }

                this.props.history.push({
                    pathname: "/GP2AfficheResultats",
                    state: {
                        serial: this.state.serial,
                        latest: data.latest,
                        request: data.request,
                        all: data.all
                    }
                });
            })
            .catch((error) => {
                this.props.history.push({
                    pathname: "/GP2Error",
                    state: {
                        serial: this.state.serial
                    }
                });
            });
    };

    render() {
        return (
            <Fragment>
                <Breadcrumb titre="Testeur GP2" ico="ico--testeur" />

                <div className="vertical-center text-center wrapper-90">
                    <div className="ico__xl ico--code ico--center"></div>

                    <p className="vertical-center__item">
                        Veuillez saisir le n° de série de la centrale (GP2 ou TRT).
                    </p>

                    <form
                        className="vertical-center__item"
                        method="POST"
                        onSubmit={this.handleSubmit}
                    >
                        <input
                            type="text"
                            id="serial"
                            onChange={this.handleSerialChange}
                            placeholder="N° de la centrale"
                        />
                        {this.state.errors.serial ? (
                            <div> {this.state.errors.serial}</div>
                        ) : (
                            ""
                        )}

                        <Btn
                            btnCss="btn btn-primary mt-md"
                            type="submit"
                            id="submit"
                        >
                            Suivant
                        </Btn>
                    </form>

                    <blockquote>
                        *Le numéro de série de la centrale ...
                    </blockquote>
                </div>
            </Fragment>
        );
    }
}